import { DayOfWeekSchedule } from "../enums/day-of-week-schedule";
import { DocumentData } from "@angular/fire/firestore";
import { ProductScheduleSettings } from "../models/product.schedule";
import { ScheduleType } from "../enums";
import * as firebase from "firebase";
import * as moment from "moment";
import { Timeframe } from "../../models/timeframe";

export class ProductScheduleSettingsBuilder {
  public type: ScheduleType;
  public dow?: DayOfWeekSchedule;
  public blackout: string[];
  public availability: Timeframe;
  constructor() {}

  load(data: DocumentData) {
    this.type = data.type;
    this.dow = data.dow ? new DayOfWeekSchedule(data.dow) : null;
    this.blackout = data.blackout ? data.blackout : null;
    this.availability = data.availability
      ? new Timeframe(data.availability.begin, data.availability.end)
      : null;
  }
  edit(schedule: ProductScheduleSettings) {
    this.type = schedule.type;
    this.dow = schedule.dow;
    this.blackout = schedule.blackout;
    this.availability = schedule.availability;
  }

  setType(type: ScheduleType) {
    this.type = type;
    return this;
  }
  setDaysOfWeek(dow: DayOfWeekSchedule) {
    this.dow = this.type == ScheduleType.DayOfWeek ? dow : null;
    return this;
  }
  setBlackout(blackout: string[]) {
    this.blackout = this.type == ScheduleType.CustomDays ? null : blackout;
    return this;
  }
  setAvailability(from: string, to: string) {
    let f = firebase.firestore.Timestamp.fromDate(moment(from).toDate());
    let t =
      to == null
        ? null
        : firebase.firestore.Timestamp.fromDate(moment(to).toDate());
    this.availability = new Timeframe(f, t);
    return this;
  }
}
